import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unified-data',
  templateUrl: './unified-data.component.html',
  styleUrls: ['./unified-data.component.sass']
})
export class UnifiedDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
